import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(username, newUsername) {
  return yield oncallFetch("/api/oncall/administration/users/change-username", {
    username,
    newUsername,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/users/change-username.js